/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: select-Widget - Mehrfachauswahl mit einer Liste
 *
 * Das select-Widget bietet die Möglichkeit einen oder mehrere Werte auszuwählen.
 * Die Werte die zur Auswahl stehen werden in einer Liste angezeigt.
 * Werte die bereits ausgewählt wurden, werden markiert angezeigt.
 *
 * Die Steuerung des Widgets basiert auf folgender Widget-Struktur:
 *
 "fields": [
    {
        "id": "sources",
        "length": 80,
        "label": "Sources",
        "unitLabel": "",
        "description": "Sources",
        "placeholder": "Sources",
        "widget": "select",
        "maxItems": 3,
        "visibleItems": 4,
        "group": null,
        "value": "",
        "enums": []
        "validation": "^[0-9]?[0-9]{1}$|^100$",
        "validationState": null,
        "validationMessage": null
    },
 *
 * Im select-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes (hier keine Bedeutung)
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel    - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde (hier keine Bedeutung)
 * widget        - Bezeichnung des Widgets. Hier mit "select" belegt
 * maxItems     - Maximale Anzahl an auswählbaren Werten/Zeichen
 * visibleItems - Anzahl sichtbarer Werte in der Liste. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktuelle Auswahl. Diese werden in der Liste markiert.
 * enums         - Alle Auswahlmöglichkeiten
 * validation    - RegEx zur Validierung der Eingabe (hier ohne Bedeutung)
 * validationState   - Zustand der Validierung (hier ohne Bedeutung)
 * validationMessage - Fehlermeldung, falls Validierung erfolglos (hier ohne Bedeutung)
 *
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as appActions from "../../../../store/actions/appActions";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-material.css'


class Select extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.gridApi = null;
        this.gridColumnApi = null;

        this.maxItems = -1;
        this.visibleItems = 5;

        this.rowHeight = 40;
        this.headerHeight = 0;
    }

    /*==========================================================================
     *
     * RENDER - SECTION
     *
     *==========================================================================*/
    render() {
        if (this.debug) console.log("Select:render()")

        this.maxItems = -1;
        if (this.props.field.hasOwnProperty('maxItems')) {
            this.maxItems = this.props.field.maxItems;
        }

        if (this.props.field.hasOwnProperty('visibleItems')) {
            this.visibleItems = this.props.field.visibleItems;
        }

        const columnsDefs = [
            {
                headerName: (this.maxItems === 1) ? "Single Select" : "Multi Select",
                field: "label",
                //width: (window.innerWidth / 2) / 3 * 2 - 65,
                checkboxSelection: true,
                resizable: true,
                suppressMenu: true
            },
        ];

        // Column Definitions
        const defaultColDef = {
            sortable: true,
            editable: false,
            filter: true,
            resizable: true,
            enableValue: true,
            enableRowGroup: true,
            enablePivot: true
        };

        const onGridReady = (params) => {
            if (this.debug) console.log('onGridReady()', this.props.value);

            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;

            var selected = this.props.value;

            if (!Array.isArray(selected)) {
                console.log("widget.value muss ein Array sein!");
                return;
            }

            this.gridApi.sizeColumnsToFit()

            this.gridApi.forEachNode(function (node, index) {
                if (selected.includes(node.data.id)) node.setSelected(true)
            });
        };

        const onSelectionChanged = (e) => {
            let selected = [];
            let selectedRows = this.gridApi.getSelectedRows();

            selectedRows.forEach(function (selectedRow, index) {
                selected.push(selectedRow.id)
            });
            this.props.onSelect(selected);
        };

        // calculate height
        let height = this.visibleItems * this.rowHeight + this.headerHeight + 1;

        return (
            <div className="w-full h-full ag-theme-material" style={{ height: height + 'px' }}>
                <AgGridReact
                    id="myGrid"
                    onGridReady={onGridReady}

                    // Column
                    columnDefs={columnsDefs}
                    defaultColDef={defaultColDef}

                    // Row
                    rowData={this.props.field.enums}
                    rowHeight={40}
                    rowSelection={(this.maxItems === 1) ? "single" : "multiple"}
                    rowMultiSelectWithClick={true}
                    onSelectionChanged={onSelectionChanged}
                    enableHorizontalScrollbar={0}

                    // Header
                    headerHeight={this.headerHeight}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Select);